import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinambegaontaluka() {



  const cardData =
  {
    keyword: 'Cab Service in Ambegaon Taluka',
    heading: 'Sanavi Travels: Cab Service in Ambegaon Taluka',
    headingDescription: 'Cab Service in Ambegaon Taluka offers reliable, safe, and affordable taxi services for local travel, outstation trips, airport transfers, corporate travel, and family tours. With a wide range of well-maintained vehicles including hatchbacks, sedans, SUVs, and luxury cars, our professional chauffeurs ensure a comfortable and punctual journey. Providing 24/7 cab booking, transparent fares, doorstep pickup, and flexible one-way or round-trip options, cab services in Ambegaon Taluka are ideal for travel to Pune, Mumbai, Shirdi, Konkan, Mahabaleshwar, and other nearby destinations with complete peace of mind.',

    top: 'Top Places to Visit in Ambegaon with Sanavi Travels',


"topPlaces": [
  {
    "title": "Ambegaon Taluka",
    "description": "Ambegaon is a picturesque taluka in Pune district, located in the northern part of the Sahyadri ranges. Known for its rugged hills, dense forests, ancient caves, and historical forts, Ambegaon holds immense archaeological and cultural significance. The region is especially famous for its connection to Maratha history and ancient Buddhist heritage, making it a unique blend of nature, spirituality, and history."
  },
  {
    "title": "Bhimashankar Temple",
    "description": "Bhimashankar Temple is one of the 12 Jyotirlingas of Lord Shiva and the most sacred site in Ambegaon taluka. Nestled amidst dense forests of the Western Ghats, the temple is both a major pilgrimage destination and a biodiversity hotspot. Devotees and tourists visit throughout the year to experience spiritual peace, misty weather, and scenic forest surroundings."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Surrounding the temple, Bhimashankar Wildlife Sanctuary is a protected forest area known for its rich biodiversity. It is home to the Indian giant squirrel (Shekru), numerous bird species, medicinal plants, and dense evergreen forests. Nature trails and eco-tourism activities attract wildlife lovers and researchers."
  },
  {
    "title": "Manchar Town",
    "description": "Manchar is the main town and commercial center of Ambegaon taluka. It serves as a base for travelers visiting Bhimashankar and nearby forts. The town offers local markets, accommodation, and a glimpse into rural Maharashtrian lifestyle."
  },
  {
    "title": "Ahupe Ghat",
    "description": "Ahupe Ghat is a scenic mountain pass near Ambegaon that connects the Deccan plateau to the Konkan region. Known for its breathtaking valley views, waterfalls, and winding roads, the ghat is especially beautiful during the monsoon season."
  },
  {
    "title": "Kailasgad Fort",
    "description": "Kailasgad Fort is a lesser-known hill fort in Ambegaon taluka, offering a peaceful trekking experience. The fort provides panoramic views of the surrounding hills and valleys and is ideal for trekkers seeking solitude and untouched landscapes."
  },
  {
    "title": "Shrivardhan and Manaranjan Forts (Rajmachi Nearby)",
    "description": "Located close to Ambegaon, these twin forts of Rajmachi are historically significant Maratha strongholds. Surrounded by dense forests and valleys, they are popular for trekking, camping, and experiencing monsoon beauty."
  },
  {
    "title": "Ancient Rock-Cut Caves",
    "description": "Ambegaon taluka is dotted with several ancient Buddhist rock-cut caves, reflecting the region’s importance as a spiritual and trade center in ancient times. These caves offer insight into early Indian architecture and monastic life."
  },
  {
    "title": "Village Life and Rural Tourism",
    "description": "The villages of Ambegaon offer authentic rural experiences, with farming activities, traditional cuisine, and local festivals. Visitors can engage with local communities and enjoy the peaceful countryside atmosphere."
  },
  {
    "title": "Monsoon Waterfalls and Nature Trails",
    "description": "During the monsoon, Ambegaon transforms into a lush green paradise with numerous seasonal waterfalls, misty forests, and scenic trekking routes. These natural attractions make it a favorite destination for nature lovers and photographers."
  }
]
,



"services": [
{
"name": "Cab Service in Ambegaon Taluka",
"description": "Cab Service in Ambegaon Taluka provides reliable, safe, and comfortable taxi services for local travel, sightseeing, and outstation trips. Equipped with well-maintained vehicles and professional drivers, it ensures a smooth and hassle-free journey. Perfect for families, tourists, corporate travelers, and daily commuters, this service offers flexible pickup and drop options, customizable travel plans, and excellent customer support across Ambegaon Taluka and nearby areas, making every trip convenient and enjoyable."
},
{
"name": "Taxi Service Ambegaon",
"description": "Taxi Service Ambegaon delivers professional and timely cab services for city travel, airport transfers, long-distance trips, and daily commuting. With courteous drivers, modern vehicles, and a focus on safety and punctuality, it provides comfortable and convenient transportation for residents, tourists, and corporate clients traveling within Ambegaon Taluka and nearby regions."
},
{
"name": "AC Cab Ambegaon",
"description": "AC Cab Ambegaon offers fully air-conditioned vehicles for a comfortable, refreshing, and relaxing travel experience. Ideal for long-distance trips, family outings, corporate travel, and tourist journeys, these cabs provide smooth rides, modern interiors, and professional drivers who prioritize passenger safety and comfort across Ambegaon Taluka and surrounding areas."
},
{
"name": "Local Cab Ambegaon",
"description": "Local Cab Ambegaon provides convenient and reliable taxi services within Ambegaon Taluka for errands, sightseeing, shopping, and daily commuting. With experienced drivers, well-maintained vehicles, and flexible scheduling, it ensures safe, hassle-free, and timely transportation for residents and visitors navigating the region."
},
{
"name": "Outstation Cab Ambegaon",
"description": "Outstation Cab Ambegaon specializes in long-distance travel to nearby cities, tourist destinations, and weekend getaways. With spacious, comfortable vehicles, skilled drivers, and customizable itineraries, it ensures safe, convenient, and enjoyable journeys for families, groups, and solo travelers venturing outside Ambegaon Taluka."
},
{
"name": "Affordable Cab Ambegaon",
"description": "Affordable Cab Ambegaon combines budget-friendly pricing with dependable and comfortable taxi services. Suitable for families, tourists, corporate travelers, and daily commuters, it provides well-maintained vehicles, professional drivers, and timely service, making it a preferred choice for cost-conscious passengers traveling in and around Ambegaon Taluka without compromising on safety or convenience."
},
{
"name": "Chauffeur Driven Cab Ambegaon",
"description": "Chauffeur Driven Cab Ambegaon offers professional drivers who handle navigation, traffic, and schedules, allowing passengers to enjoy a stress-free and relaxing journey. Perfect for VIP clients, corporate teams, families, and tourists, it ensures smooth, safe, and comfortable travel throughout Ambegaon Taluka and neighboring regions."
},
{
"name": "Best Cab Service Ambegaon",
"description": "Best Cab Service Ambegaon is known for its punctuality, clean and well-maintained vehicles, and exceptional customer service. Offering city travel, airport transfers, sightseeing tours, and outstation trips, it provides reliable, safe, and comfortable transportation for individuals, families, and corporate clients traveling within Ambegaon Taluka and beyond."
},
{
"name": "Tourist Cab Ambegaon",
"description": "Tourist Cab Ambegaon caters to travelers exploring Ambegaon and nearby attractions. With flexible itineraries, knowledgeable drivers, and comfortable vehicles, it provides a seamless sightseeing experience, allowing tourists to enjoy historical, cultural, and scenic destinations without worrying about transportation logistics."
},
{
"name": "Airport Cab Ambegaon",
"description": "Airport Cab Ambegaon provides timely pickup and drop services to and from nearby airports. With professional drivers, spacious vehicles, and flexible scheduling, it ensures a smooth, stress-free travel experience for business travelers, tourists, and families flying in or out of Ambegaon Taluka."
},
{
"name": "Corporate Cab Ambegaon",
"description": "Corporate Cab Ambegaon offers dedicated taxi services for executives, employees, and business teams. With punctual pickups, clean vehicles, and courteous drivers, it ensures safe, reliable, and efficient transportation for office travel, meetings, and corporate events in Ambegaon Taluka and surrounding areas."
},
{
"name": "Online Cab Booking Ambegaon",
"description": "Online Cab Booking Ambegaon allows passengers to reserve cabs quickly and conveniently with instant confirmation. Offering multiple vehicle options, transparent pricing, and flexible scheduling, it simplifies travel planning for families, tourists, corporate clients, and local commuters traveling to or from Ambegaon Taluka."
},
{
"name": "Family Cab Ambegaon",
"description": "Family Cab Ambegaon provides spacious and comfortable vehicles suitable for family travel. Designed to accommodate passengers of all ages, it ensures safe, convenient, and enjoyable journeys for family outings, vacations, day trips, and sightseeing tours within Ambegaon Taluka and nearby regions."
},
{
"name": "24x7 Taxi Ambegaon",
"description": "24x7 Taxi Ambegaon offers round-the-clock cab services to ensure passengers have reliable transportation anytime. With professional drivers, well-maintained vehicles, and prompt response times, it provides safe and convenient travel solutions for emergencies, late-night rides, airport transfers, and other travel needs in Ambegaon Taluka."
},
{
"name": "Ambegaon Travel Taxi",
"description": "Ambegaon Travel Taxi provides comprehensive cab services for local commuting, tourist travel, and outstation trips. Combining comfort, safety, affordability, and professional service, it caters to families, tourists, and corporate travelers seeking dependable and convenient transportation in Ambegaon Taluka and surrounding areas."
}
],
"tableData": [
["Cab Service in Ambegaon Taluka", "Taxi Service Ambegaon"],
["AC Cab Ambegaon", "Local Cab Ambegaon"],
["Outstation Cab Ambegaon", "Affordable Cab Ambegaon"],
["Chauffeur Driven Cab Ambegaon", "Best Cab Service Ambegaon"],
["Tourist Cab Ambegaon", "Airport Cab Ambegaon"],
["Corporate Cab Ambegaon", "Online Cab Booking Ambegaon"],
["Family Cab Ambegaon", "24x7 Taxi Ambegaon"],
["Ambegaon Travel Taxi", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Ambegaon Taluka with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable cab services in Ambegaon Taluka for local travel, airport transfers, sightseeing tours, and outstation trips."
  },
  {
    "WhyChooseheading": "Clean and Well‑Maintained Cabs",
    "WhyChoosedescription": "Our cabs are regularly serviced, air‑conditioned, and well‑kept to ensure a smooth and pleasant ride throughout Ambegaon Taluka."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with routes in Ambegaon Taluka and surrounding areas, ensuring safe, timely, and stress‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for all cab services in Ambegaon Taluka, including fuel and toll charges, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with cab bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Ride Options",
    "WhyChoosedescription": "Choose from local rides, hourly hires, airport transfers, and outstation cab packages based on your travel plans."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for cab service in Ambegaon Taluka."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services in Ambegaon Taluka?',
    answer: 'Yes, Sanavi Travels offers dependable cab services in Ambegaon Taluka for local and outstation travel.'
  },
  {
    question: 'How can I book a cab in Ambegaon Taluka?',
    answer: 'You can easily book a cab through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cab services are available in Ambegaon Taluka?',
    answer: 'Sanavi Travels offers local rides, airport transfers, hourly hires, and outstation cab services in Ambegaon Taluka.'
  },
  {
    question: 'Are the drivers experienced with routes in Ambegaon Taluka?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with routes in Ambegaon Taluka and nearby areas.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Ambegaon Taluka.'
  },
  {
    question: 'Is the cab service in Ambegaon Taluka available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock cab services in Ambegaon Taluka to suit your travel schedule.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for cab services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for cab bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your cab ride in Ambegaon Taluka.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan More',
    feedback: 'Booked a cab in Ambegaon Taluka with Sanavi Travels — excellent service, clean car, and friendly driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Aditi Patil',
    feedback: 'Great cab experience in Ambegaon Taluka with prompt pickup and smooth ride. Highly recommended!',
    rating: 5
  }
];





























































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Taxi",
  "name": "Cab Service in Ambegaon Taluka - Sanavi Travels",
  "description": "Sanavi Travels provides reliable cab services in Ambegaon Taluka. AC, local, outstation, airport, corporate, and family cabs available. Chauffeur-driven, affordable, and 24x7 service. Book online now.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "32"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Cab Service in Ambegaon Taluka | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC, local, outstation, airport, corporate, and family cabs in Ambegaon Taluka with Sanavi Travels. Affordable, chauffeur-driven, 24x7 cab service. Online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/150.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinambegaontaluka;